<div id="map" [style.height.px]="height">
</div>
<div class="info">
    <span>
        <nz-input-group nzSize="small" [nzSuffix]="suffixIconSearch">
            <input id="tipinput" autocomplete="off" type="text" nz-input placeholder="input search text" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
            <i nz-icon nzType="search"></i>
        </ng-template>
    </span>

    点击地图，获取经纬度 <span *ngIf="lnglat">{{lnglat[0]}},{{lnglat[1]}}</span>

</div>